// PROPOSITO: todo lo compartido del panel de Flor. Ella trabaja en pantalla grande.
// DEPENDENCIAS: react-router-dom, Avisos.
// NO OBVIO: aqui NO va la barra de sincronizacion. La autoria es siempre en linea: dos versiones
// de un mismo menu al reconectar no tienen desempate honesto.

import { Suspense } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { Avisos } from '@/components/Avisos'

const DESTINOS = [
  { a: '/panel', texto: 'Hoy' },
  { a: '/alumnas', texto: 'Alumnas' },
  { a: '/ejercicios', texto: 'Ejercicios' },
  { a: '/menus', texto: 'Menús' },
  { a: '/cobros', texto: 'Cobros' },
]

export function EntrenadoraLayout() {
  return (
    <div className="min-h-screen bg-superficie-baja">
      <header className="sticky top-0 z-navegacion border-b border-borde bg-superficie">
        <nav aria-label="Navegación principal" className="mx-auto flex max-w-6xl gap-1 px-4">
          {DESTINOS.map(destino => (
            <NavLink
              key={destino.a}
              to={destino.a}
              className={({ isActive }) =>
                `flex h-comodo items-center px-4 text-sm ${
                  isActive
                    ? 'border-b-2 border-primario font-fuerte text-primario'
                    : 'text-sobre-media'
                }`
              }
            >
              {destino.texto}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="mx-auto w-full max-w-6xl px-4 py-6">
        <Suspense fallback={<div className="py-12 text-center text-sobre-tenue">Cargando…</div>}>
          <Outlet />
        </Suspense>
      </main>

      <Avisos />
    </div>
  )
}
